import { Component, Inject, LOCALE_ID } from '@angular/core';
import { Router } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { TranslationConfig } from 'src/app/utils/translate-config';
import { SwiperOptions } from 'swiper';
import { TeaserTopMobileComponent } from '../../teaser-top-mobile/teaser-top-mobile.component';
import { ChargebackService } from 'src/app/services/profile/chargeback.service';
import { BonusLotteryService } from 'src/app/services/profile/bonuslottery.service';
import { LICENCE } from 'src/app/global.tokens';
import { distinctUntilChanged, switchMap } from 'rxjs';

@Component({
  selector: 'app-teaser-top-desktop',
  templateUrl: './teaser-top-desktop.component.html',
  styleUrls: ['./teaser-top-desktop.component.scss']
})
export class TeaserTopDesktopComponent extends TeaserTopMobileComponent {

  constructor(
    protected loginStatusService: LoginStatusService,
    @Inject(LOCALE_ID) public locale: string,
    @Inject(LICENCE) public licence: string,
    protected apollo: Apollo,
    protected router: Router,
    protected translationConfig: TranslationConfig,
    protected licenceService: LicenceService,
    protected chargebackService: ChargebackService,
    protected bonusLotteryService: BonusLotteryService,

  ) {
    super(
      loginStatusService,
      locale,
      licence,
      apollo,
      router,
      translationConfig,
      chargebackService,
      bonusLotteryService,
      licenceService
    )
  }

  config: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 50,
    navigation: true,
    pagination: { clickable: true },
    scrollbar: { draggable: true },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    }
  };

  multiTeaser: any = {
    "teaser": [{
      "name": "activePromotionDisplay",
      "url": "client-area/main",
      "msg": "You got a free ticket for Bison Lottery! Spin the wheel!",
      "iconName": "star.png",
      "__typename": "Teaser"
    }, {
      "name": "activePromotionDisplay",
      "url": "christmas-calendar",
      "msg": "Hey! Check the calendar and get your gift!",
      "iconName": "icon-xmas-teaser-on.png",
      "__typename": "Teaser"
    }]
  };

  ngOnInit(): void {
    this.getData();
    this.loginStatusService.getIfUserLogged().pipe(
      distinctUntilChanged(),
      switchMap((status) => {
        return this.campaignService.getActiveCampaign()
      })
    ).subscribe(resp => this.isXmasCampaign = resp?.campaign.name.toLowerCase().includes('xmas'))
  }

}
